// assets/collection-long-description.js
(() => {
  function init(scope = document) {
    const wraps = scope.querySelectorAll("[data-collection-long-desc]");
    if (!wraps.length) return;

    wraps.forEach((wrap) => {
      const enable = String(wrap.dataset.enableReadMore) === "true";
      if (!enable) return;

      const content = wrap.querySelector(".collection-long-desc__content");
      const toggle = wrap.querySelector("[data-read-more-toggle]");
      const label = wrap.querySelector("[data-read-more-label]");
      if (!content || !toggle || !label) return;

      const lines = parseInt(wrap.dataset.lineLimit || "5", 10);
      const moreText = toggle.dataset.moreText || label.textContent.trim() || "Leggi di più";
      const lessText = toggle.dataset.lessText || "Leggi meno";

      // Set css custom property used by clamp
      wrap.style.setProperty("--clamp-lines", String(isNaN(lines) ? 5 : lines));

      // Start collapsed
      content.classList.add("is-collapsed");
      toggle.hidden = true;
      toggle.setAttribute("aria-expanded", "false");

	  const needsToggle = () => {
  const tolerance = 2; // evita falsi positivi per rounding
  return content.scrollHeight - content.clientHeight > tolerance;
};

const refresh = () => {
  const isExpanded = toggle.getAttribute("aria-expanded") === "true";
  if (isExpanded) return; // rispetto la scelta utente

  // forziamo stato collapsed per misurare correttamente
  content.classList.add("is-collapsed");

  if (needsToggle()) {
    toggle.hidden = false;
    label.textContent = moreText;
  } else {
    // 🔑 CASO CHIAVE: non serve il bottone
    toggle.hidden = true;
    content.classList.remove("is-collapsed"); // testo libero
  }
};


      // First pass after layout
      requestAnimationFrame(refresh);

      // Recompute on resize (font changes / responsive)
      let raf = null;
      window.addEventListener("resize", () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(refresh);
      });

      toggle.addEventListener("click", () => {
        const expanded = toggle.getAttribute("aria-expanded") === "true";

        if (expanded) {
          // collapse
          content.classList.add("is-collapsed");
          toggle.setAttribute("aria-expanded", "false");
          label.textContent = moreText;

          // bring user back to the start of the block (optional but nice)
          // wrap.scrollIntoView({ behavior: "smooth", block: "nearest" });
        } else {
          // expand
          content.classList.remove("is-collapsed");
          toggle.setAttribute("aria-expanded", "true");
          label.textContent = lessText;
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
